export default __webpack_public_path__ + "static/IBMPlexSans-BoldItalic-Latin1-0c7dce9f5ab137a8c68fe90cd9f15c96.woff";